import React, { useCallback, useMemo } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { deleteSearchParam } from 'helpers/deleteSearchParam';

import {
  btag,
  printMissingConfigError,
  pushToDataLayer,
  SiteConfigManager,
  useApplicationState,
} from '@atlas/core';
import { CmdLink, signInRoutes, staticRoutes } from '@atlas/routing';
import { BasePopup, Icon, Label } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';
import history from 'components/Layout/history';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';
import SignupButtonWithPopup from 'src/components/SignUp/SignUpButtonWithPopup';

const { phone } = signInRoutes;
const { signup } = staticRoutes;

export const PopupSignUpDelay = () => {
  const isEnableRegistration = SiteConfigManager.getConfig('config.config.enable_registration');
  const block = SiteConfigManager.getConfig('config.config.registration.desktop_popup_block');
  const { pathname, search } = history.location;
  const { authenticated } = useApplicationState();

  const showSignUpPopup = SiteConfigManager.getConfig('config.config.registration.showInPopup');

  const staticBlockOptions = useMemo(() => ({ source: block }), [block]);
  const renderFallback = useMemo(
    () => (
      <div className="sign-up-delay-fallback">
        <Label className="sign-up-delay-fallback__title" message="registration_popup_title" />
        <Label
          className="sign-up-delay-fallback__description"
          message="registration_popup_description"
        />
      </div>
    ),
    [],
  );

  const close = useCallback(() => {
    const newUrl = deleteSearchParam(search, ['cmd']);
    history.replace({ search: newUrl });
  }, [search]);

  const handleSignUpClick = useCallback(() => {
    pushToDataLayer('registration_pop-up_CTA_click', btag);
  }, []);

  if (!block) {
    printMissingConfigError('config.config.registration.desktop_popup_block');
  }

  useSetNextShowPopupSignUpDelay();

  if (authenticated) {
    const newSearch = deleteSearchParam(search, ['cmd']);
    const to = `${pathname}?${newSearch}`;
    return <Redirect to={to} />;
  }

  return (
    <BasePopup className="popup__sign-up-delay">
      <div className="popup__content">
        <Icon className="popup__icon" name="close" onClick={close} />

        <StaticBlock fallback={renderFallback} options={staticBlockOptions} />
      </div>

      <div className="popup__footer">
        <div className="popup__footer-item">
          <CmdLink className="header__signin btn secondary big block" cmd="signin" path={phone}>
            <Label message="login" />
          </CmdLink>
        </div>

        {isEnableRegistration && (
          <>
            {showSignUpPopup ? (
              <SignupButtonWithPopup labelMessagePopup="registration" />
            ) : (
              <Link
                className="header__signup btn primary big block"
                onClick={handleSignUpClick}
                to={signup}
              >
                <Label message="sign up" />
              </Link>
            )}
          </>
        )}
      </div>
    </BasePopup>
  );
};
